import { EventEmitter } from "fbemitter";
import { parse } from "url";
import { stripSubdomain, isWindowDefined } from "../helpers/url";
import { getCookieValue, removeCookie } from "../client/context/cookies";

/* istanbul ignore next */
export class LoggingEmitter extends EventEmitter {
  emit(...args) {
    const { query } = parse(location.toString(), true);
    if (query && query.analytics === "true") {
      console.log(...args); //eslint-disable-line no-console
    }
    return super.emit(...args);
  }
}
const emitter = (isWindowDefined() && window.eventBus) || new LoggingEmitter();

const emit = (eventName, details) => emitter.emit(eventName, details);
const signalPageLoadData = {};
const postPageLoadData = {};
const signalPageLoadEventsToTrack = ["tracking.productList.pageLoad"];
const postPageLoadEventsToTrack = ["tracking.identity.userStatus"];
const IDENTITY_STATUS_COOKIE = "asos-la676";

export const trackPageLoads = () => {
  //Capture selected pageLoad events
  signalPageLoadEventsToTrack.forEach(event => {
    emitter.addListener(event, payload => {
      signalPageLoadData[event] = payload;
    });
  });
  postPageLoadEventsToTrack.forEach(event => {
    emitter.addListener(event, payload => {
      postPageLoadData[event] = payload;
    });
  });

  //re-emit them for signal when they're ready
  emitter.addListener("signal-ready", () => {
    Object.keys(signalPageLoadData).forEach(event => {
      const payload = signalPageLoadData[event];
      emit(event + "-signal", payload);
    });
    Object.keys(postPageLoadData).forEach(event => {
      const payload = postPageLoadData[event];
      emit(event + "-post-load", payload);
    });
  });

  // Read cookie asos-la676 which is set by Identity
  // This will give us information if the user has signed in/registered
  // We need to remove the cookie so we don't trigger the analytics event twice
  const identityCookieValue = getCookieValue(IDENTITY_STATUS_COOKIE);

  if (identityCookieValue) {
    emit("tracking.identity.userStatus", identityCookieValue);

    const domain = `.${stripSubdomain(window.location.hostname)}`;
    removeCookie(IDENTITY_STATUS_COOKIE, domain);
  }
};

trackPageLoads();

export default emitter;

export const ANALYTICS_INTERACTION_CLICK = "click";
export const ANALYTICS_INTERACTION_EXPAND = "expand";
export const ANALYTICS_INTERACTION_HOVER = "hover";
export const ANALYTICS_INTERACTION_SAVED = "saved";
export const ANALYTICS_INTERACTION_CLOSE = "close";
export const ANALYTICS_INTERACTION_NAVIGATE = "navigate";
export const ANALYTICS_INTERACTION_IMPRESSION = "impression";
export const ANALYTICS_POSITION_HEADER = "header";
export const ANALYTICS_POSITION_FOOTER = "footer";
export const ANALYTICS_POSITION_COUNTRY_SELECTOR = "country selector modal";
export const ANALYTICS_CONTEXT = {
  navHover: "nav hover",
  openNav: "open nav section",
  social: "social icon",
  openCountryModal: "open country modal",
  footerExpandable: "concertina",
  countrySelector: "country preferences",
  minibagDeleteItem: "mini bag product delete",
  welcomeMessage: "welcome message",
  rsftWelcomeMessage: "rsft welcome message",
  deliverToDeliveryCountry: "deliver to delivery country",
  deliverElseWhere: "deliver elsewhere",
  dismissCountrySelector: "dismiss country selector"
};

export const getGender = str => {
  if (str === "men" || str === "women") return str;
  if (str === "MW") return "men";
  if (str === "WW") return "women";
};

export const trackPageInteraction = details =>
  emit("tracking.navigation.pageInteraction", details);

export const trackMiniBagProductDelete = details =>
  emit("tracking.miniBag.miniBagInteraction", details);

export const trackBannerShown = () =>
  emit("tracking.gdpr.bannerShow", {
    context: "gdpr banner shown",
    trackingFrequency: "session"
  });

export const trackBannerClose = () =>
  emit("tracking.gdpr.bannerClose", {
    context: "gdpr banner closed",
    trackingFrequency: "session"
  });

export const trackGdprKeepSending = basicDetails =>
  emit("tracking.gdpr.pageLoad", {
    ...basicDetails,
    pageName: "gdpr keep sending",
    pageTitle: "gdpr keep sending"
  });

export const trackGdprStopSending = basicDetails =>
  emit("tracking.gdpr.pageLoad", {
    ...basicDetails,
    pageName: "gdpr stop sending",
    pageTitle: "gdpr stop sending"
  });

export const trackOpenGdprModal = basicDetails =>
  emit("tracking.gdpr.pageLoad", {
    ...basicDetails,
    pageName: "gdpr control my content",
    pageTitle: "gdpr control my content"
  });

export const trackNativeAppBannerGetApp = platform =>
  emit("tracking.appbanner.installTheApp", platform);
